export const ItemHubEvents = {
    ReceiveStatusUpdate: "ReceiveStatusUpdate"
}

export const ItemHubMethods = {
    EnlistClientConnection: "EnlistClientConnection",
    SendStatusUpdate: "SendStatusUpdate"
}